<template>
  <div>
    <h3 class="modal-title"> DIGITAL DOCUMENT </h3>
    <b-form-group :class="{'error-input' : $v.data_document.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.data_document.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeDocument">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveDocument">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_document: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_document: {
        title: '',
      },
    };
  },
  computed: {
    generateDataDocument() {
      const data = {
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_document.title,
        component_master_id: this.dataMaster.id,
        info: '-',
        type_platform: 1,
      };
      return data;
    },

    generateDataDocumentUpdate() {
      const data = {
        value_id: '0',
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_document.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: this.dataEdit.info,
        type_platform: 1,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_document.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent']),

    saveDocument() {
      this.$v.data_document.$touch();
      if (!this.$v.data_document.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataDocument,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataDocumentUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.$emit('close-field');
        this.data_document.title = '';
        setTimeout(() => {
          this.$v.data_document.$reset();
        }, 1000);
      }
    },

    closeDocument() {
      this.$emit('close-field');
      this.data_document.title = '';
      setTimeout(() => {
        this.$v.data_document.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jDigitalDocumentSetup.vue